import styled from "@emotion/styled";
import type { PropsWithChildren } from "react";

import { FONT_WEIGHT_SEMI_BOLD } from "@skilitics/designer-ui-components";
import { useFormatMessage, type FormatMessages } from "@skilitics/localization";

const Container = styled.div`
  display: flex;
  flex-direction: column;

  height: 100%;
  flex: 0 0 200px;

  padding: 20px;

  border-inline-end: ${({ theme }) => `1px solid ${theme.surfaceBack_1}`};

  overflow-y: auto;

  @media screen and (min-width: 1100px) {
    flex-basis: 240px;
  }
`;

const Heading = styled.div`
  display: flex;
  width: 100%;

  color: ${({ theme }) => theme.primaryStrong};

  font-size: ${({ theme }) => theme.fontSizeLarge};
  font-weight: ${FONT_WEIGHT_SEMI_BOLD};

  padding-block-end: 8px;
  border-block-end: ${({ theme }) => `1px solid ${theme.primaryStrong}`};

  user-select: none;

  margin-bottom: 15px;
`;

export const Filters = ({ children, ...props }: PropsWithChildren) => {
  const formatMessage = useFormatMessage(formatStrings);

  return (
    <Container {...props}>
      <Heading>{formatMessage("heading")}</Heading>
      {children}
    </Container>
  );
};

const formatStrings = {
  heading: {
    en: "Filters",
  },
} satisfies FormatMessages;
